<template>
  <div v-if="showList && showList.length" class="barrage-container">
    <div class="content-wrap">
      <div
        v-for="(row, index) in showList"
        :key="index"
        :class="[
          'channel',
          'animation-' + row.list.length,
          'channel-' + (index + 1)
        ]"
      >
        <span v-for="(item, idx) in row.list" :key="idx" class="barrage-item">
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataList: []
    }
  },

  computed: {
    showList() {
      if (!this.dataList || !this.dataList.length) {
        return
      }
      const result = []

      // 取前200条即可
      const tempList = this.dataList.slice(0, 200)

      const arr1 = []
      const arr2 = []
      for (let i = 0; i < tempList.length; i++) {
        const item = tempList[i]
        if (i % 3 === 0) {
          arr1.push(`${item.companyName}  摇到${item.prizeName}`)
        } else {
          arr2.push(`${item.companyName}  摇到${item.prizeName}`)
        }
      }

      result.push({ list: arr1 })
      result.push({ list: arr2 })

      return result
    }
  },
  watch: {
    list(val) {
      this.dataList = val
    }
  },
  mounted() {
    this.dataList = this.list
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
@mixin timerValue($timer) {
  animation: barrage #{$timer}s linear 0.1s infinite;
}

@for $i from 1 through 70 {
  // 因取前200个元素作为弹幕，则最多每行200/3=约67个节点。计算最大节点所需的动画时间即可
  .animation-#{$i} {
    @if ($i % 3 == 0) {
      @include timerValue($i * 4.5);
    }
    @if ($i % 3 == 1) {
      @include timerValue($i * 5);
    }
    @if ($i % 3 == 2) {
      @include timerValue($i * 4);
    }
  }
}

.barrage-container {
  position: absolute;
  top: 3.54rem; // 277px
  left: 0;

  width: 100%;

  @keyframes barrage {
    from {
      visibility: visible;

      left: 100%;
      // transform: translate3d(0, 0, 0);
    }
    to {
      visibility: visible;

      left: 0;
      transform: translate3d(-100%, 0, 0);
    }
  }

  .content-wrap {
    position: relative;

    height: 1.6rem; // 150px

    overflow: hidden;

    .barrage-item {
      height: 0.4rem; // 20px;
      margin-left: 0.5rem;
      padding: 0 0.2rem;
      overflow: hidden;

      background: rgba(0, 0, 0, 0.4);
      border-radius: 0.2rem;

      font-size: 0.24rem;
      line-height: 0.4rem;
      text-align: center;
      white-space: nowrap;
      color: #ffffff;
    }

    .channel {
      display: flex;
      visibility: hidden;

      flex-direction: row;
      flex-wrap: nowrap;

      &.channel-1 {
        position: absolute;
        // animation: barrage 50s linear 0s infinite;
      }

      &.channel-2 {
        position: absolute;
        top: 0.6rem;
        // animation: barrage 61s linear 0s infinite;
      }

      &.channel-3 {
        position: absolute;
        top: 1.2rem;
        // animation: barrage 9s linear 0s infinite;
      }
    }
  }
}
</style>
